module.exports = __webpack_public_path__ + "img/727.bb5f97de.gif";